var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "inbox-label" }, [
        _vm._v(_vm._s(_vm.t("insurance.auto_drive_age"))),
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          fieldTitle:
            _vm.title + "_" + _vm.t("insurance.auto_drive_age", {}, "zh"),
          fieldname: "age_" + _vm.id,
          required: _vm.id === "1",
          name: "age",
          type: "number",
          min: "16",
          max: "100",
          maxlength: "3",
          fieldType: "text",
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "inbox-label" }, [
        _vm._v(_vm._s(_vm.t("insurance.auto_position"))),
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          required: _vm.id === "1",
          fieldTitle:
            _vm.title + "_" + _vm.t("insurance.auto_position", {}, "zh"),
          fieldname: "position_" + _vm.id,
          name: "position",
          maxlength: "200",
          type: "text",
          fieldType: "text",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }